import React from 'react';
import { connect } from 'react-redux';

import LinkField from 'apps/auth/components/ga/cards/details/LinkField';

const ChangePinLinkField = (props) => {
    const onClickButton = (e) => {
        e.preventDefault();
        props.setShowModal('smsConfirmation');
    };

    return <LinkField type="button" emphasizedtext icon="key" text={props.changePinButton} onClick={onClickButton} />;
};
const mapStateToProps = (state) => ({
    changePinButton: state.messages.pageMessages.changePinButton,
});
export default connect(mapStateToProps, null)(ChangePinLinkField);
